export default __webpack_public_path__ + "952dfb3bffaab058a3c42eb15a85945c.png";